import React from 'react';
import { APPOINTMENT_TYPE } from '@hopdrive/sdk-appointments';
import { Appointments } from '@gql/base-types';
import AppointmentDetailsContent from './AppointmentDetailsContent';
import MobileServiceAppointmentDetails from './MobileServiceAppointmentDetails';

type DetailComponent = React.FC<{ appointment: Appointments }>;

// AppointmentDetailsContent takes the appointment as its props object directly,
// not under an `appointment` key — wrap it so the router can call all detail
// components with a uniform signature.
const ValetDetail: DetailComponent = ({ appointment }) => <AppointmentDetailsContent {...appointment} />;

const REGISTRY: Record<string, DetailComponent> = {
  [APPOINTMENT_TYPE.MOBILE_SERVICE]: MobileServiceAppointmentDetails,
  [APPOINTMENT_TYPE.VALET]: ValetDetail,
};

const AppointmentDetailRouter: DetailComponent = ({ appointment }) => {
  const Detail = (appointment.type && REGISTRY[appointment.type]) || ValetDetail;
  return <Detail appointment={appointment} />;
};

export default AppointmentDetailRouter;
